import { useSchedule } from '../../../../../../../hooks'
import { getHasListingPublicationsInProgress } from '../../RentalPortalListingProfilePublishings.utils'

import { LISTING_PUBLICATIONS_POLL_INTERVAL } from './useListingProfilePublicationsPoll.constants'

export function useListingProfilePublicationsPoll({
  isReloading,
  publications,
  onPoll,
}) {
  function handlePollTick() {
    if (!isReloading) {
      onPoll()
    }
  }

  useSchedule(
    getHasListingPublicationsInProgress(publications)
      ? LISTING_PUBLICATIONS_POLL_INTERVAL
      : Infinity,
    handlePollTick
  )
}
